import { defineComponent as $, watchEffect as A, ref as b, computed as F, provide as L, toRef as T, cloneVNode as K, Text as q, h as v, withDirectives as G } from "vue";
import J, { popoverBodyProps as Q } from "./ghl-ui.es1072.js";
import { warnOnce as w } from "./ghl-ui.es853.js";
import X from "./ghl-ui.es713.js";
import Y from "./ghl-ui.es712.js";
import P from "./ghl-ui.es706.js";
import Z from "./ghl-ui.es714.js";
import { getFirstSlotVNode as _ } from "./ghl-ui.es872.js";
import ee from "./ghl-ui.es878.js";
import ne from "./ghl-ui.es719.js";
import te from "./ghl-ui.es879.js";
import { keep as oe } from "./ghl-ui.es930.js";
import re from "./ghl-ui.es855.js";
import { call as B } from "./ghl-ui.es876.js";
import { useAdjustedTo as ie } from "./ghl-ui.es877.js";
const ae = Object.keys(Q), le = {
  focus: ["onFocus", "onBlur"],
  click: ["onClick"],
  hover: ["onMouseenter", "onMouseleave"],
  manual: [],
  nested: ["onFocus", "onBlur", "onMouseenter", "onMouseleave", "onClick"]
};
function se(e, p, c) {
  le[p].forEach((t) => {
    e.props ? e.props = Object.assign({}, e.props) : e.props = {};
    const d = e.props[t], i = c[t];
    d ? e.props[t] = (...r) => {
      d(...r), i(...r);
    } : e.props[t] = i;
  });
}
const de = {
  show: {
    type: Boolean,
    default: void 0
  },
  defaultShow: Boolean,
  showArrow: {
    type: Boolean,
    default: !0
  },
  trigger: {
    type: String,
    default: "hover"
  },
  delay: {
    type: Number,
    default: 100
  },
  duration: {
    type: Number,
    default: 100
  },
  raw: Boolean,
  placement: {
    type: String,
    default: "top"
  },
  x: Number,
  y: Number,
  arrowPointToCenter: Boolean,
  disabled: Boolean,
  getDisabled: Function,
  displayDirective: {
    type: String,
    default: "if"
  },
  arrowClass: String,
  arrowStyle: [String, Object],
  arrowWrapperClass: String,
  arrowWrapperStyle: [String, Object],
  flip: {
    type: Boolean,
    default: !0
  },
  animated: {
    type: Boolean,
    default: !0
  },
  width: {
    type: [Number, String],
    default: void 0
  },
  overlap: Boolean,
  keepAliveOnHover: {
    type: Boolean,
    default: !0
  },
  zIndex: Number,
  to: ie.propTo,
  scrollable: Boolean,
  contentClass: String,
  contentStyle: [Object, String],
  headerClass: String,
  headerStyle: [Object, String],
  footerClass: String,
  footerStyle: [Object, String],
  // events
  onClickoutside: Function,
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  // internal
  internalDeactivateImmediately: Boolean,
  internalSyncTargetWithParent: Boolean,
  internalInheritedEventHandlers: {
    type: Array,
    default: () => []
  },
  internalTrapFocus: Boolean,
  internalExtraClass: {
    type: Array,
    default: () => []
  },
  // deprecated
  onShow: [Function, Array],
  onHide: [Function, Array],
  arrow: {
    type: Boolean,
    default: void 0
  },
  minWidth: Number,
  maxWidth: Number
}, ue = Object.assign(Object.assign(Object.assign({}, re.props), de), {
  internalOnAfterLeave: Function,
  internalRenderBody: Function
}), Ie = $({
  name: "Popover",
  inheritAttrs: !1,
  props: ue,
  __popover__: !0,
  setup(e) {
    process.env.NODE_ENV !== "production" && A(() => {
      e.maxWidth !== void 0 && w("popover", "`max-width` is deprecated, please use `style` instead."), e.minWidth !== void 0 && w("popover", "`min-width` is deprecated, please use `style` instead."), e.arrow !== void 0 && w("popover", "`arrow` is deprecated, please use `showArrow` instead."), e.onHide !== void 0 && w("popover", "`on-hide` is deprecated, please use `on-update:show` instead."), e.onShow !== void 0 && w("popover", "`on-show` is deprecated, please use `on-update:show` instead.");
    });
    const p = X(), c = b(null), t = F(() => e.show), d = b(e.defaultShow), i = Y(t, d), r = P(() => e.disabled ? !1 : i.value), o = () => {
      if (e.disabled)
        return !0;
      const {
        getDisabled: n
      } = e;
      return !!(n != null && n());
    }, u = () => o() ? !1 : i.value, l = Z(e, ["arrow", "showArrow"]), s = F(() => e.overlap ? !1 : l.value);
    let C = null;
    const g = b(null), m = b(null), E = P(() => e.x !== void 0 && e.y !== void 0);
    function f(n) {
      const {
        "onUpdate:show": a,
        onUpdateShow: h,
        onShow: R,
        onHide: k
      } = e;
      d.value = n, a && B(a, n), h && B(h, n), n && R && B(R, !0), n && k && B(k, !1);
    }
    function x() {
      C && C.syncPosition();
    }
    function y() {
      const {
        value: n
      } = g;
      n && (window.clearTimeout(n), g.value = null);
    }
    function S() {
      const {
        value: n
      } = m;
      n && (window.clearTimeout(n), m.value = null);
    }
    function O() {
      const n = o();
      if (e.trigger === "focus" && !n) {
        if (u())
          return;
        f(!0);
      }
    }
    function D() {
      const n = o();
      if (e.trigger === "focus" && !n) {
        if (!u())
          return;
        f(!1);
      }
    }
    function I() {
      const n = o();
      if (e.trigger === "hover" && !n) {
        if (S(), g.value !== null || u())
          return;
        const a = () => {
          f(!0), g.value = null;
        }, {
          delay: h
        } = e;
        h === 0 ? a() : g.value = window.setTimeout(a, h);
      }
    }
    function M() {
      const n = o();
      if (e.trigger === "hover" && !n) {
        if (y(), m.value !== null || !u())
          return;
        const a = () => {
          f(!1), m.value = null;
        }, {
          duration: h
        } = e;
        h === 0 ? a() : m.value = window.setTimeout(a, h);
      }
    }
    function H() {
      M();
    }
    function j(n) {
      var a;
      u() && (e.trigger === "click" && (y(), S(), f(!1)), (a = e.onClickoutside) === null || a === void 0 || a.call(e, n));
    }
    function W() {
      if (e.trigger === "click" && !o()) {
        y(), S();
        const n = !u();
        f(n);
      }
    }
    function N(n) {
      e.internalTrapFocus && n.key === "Escape" && (y(), S(), f(!1));
    }
    function z(n) {
      d.value = n;
    }
    function U() {
      var n;
      return (n = c.value) === null || n === void 0 ? void 0 : n.targetRef;
    }
    function V(n) {
      C = n;
    }
    return L("NPopover", {
      getTriggerElement: U,
      handleKeydown: N,
      handleMouseEnter: I,
      handleMouseLeave: M,
      handleClickOutside: j,
      handleMouseMoveOutside: H,
      setBodyInstance: V,
      positionManuallyRef: E,
      isMountedRef: p,
      zIndexRef: T(e, "zIndex"),
      extraClassRef: T(e, "internalExtraClass"),
      internalRenderBodyRef: T(e, "internalRenderBody")
    }), A(() => {
      i.value && o() && f(!1);
    }), {
      binderInstRef: c,
      positionManually: E,
      mergedShowConsideringDisabledProp: r,
      // if to show popover body
      uncontrolledShow: d,
      mergedShowArrow: s,
      getMergedShow: u,
      setShow: z,
      handleClick: W,
      handleMouseEnter: I,
      handleMouseLeave: M,
      handleFocus: O,
      handleBlur: D,
      syncPosition: x
    };
  },
  render() {
    var e;
    const {
      positionManually: p,
      $slots: c
    } = this;
    let t, d = !1;
    if (!p && (c.activator ? t = _(c, "activator") : t = _(c, "trigger"), t)) {
      t = K(t), t = t.type === q ? v("span", [t]) : t;
      const i = {
        onClick: this.handleClick,
        onMouseenter: this.handleMouseEnter,
        onMouseleave: this.handleMouseLeave,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      };
      if (!((e = t.type) === null || e === void 0) && e.__popover__)
        d = !0, t.props || (t.props = {
          internalSyncTargetWithParent: !0,
          internalInheritedEventHandlers: []
        }), t.props.internalSyncTargetWithParent = !0, t.props.internalInheritedEventHandlers ? t.props.internalInheritedEventHandlers = [i, ...t.props.internalInheritedEventHandlers] : t.props.internalInheritedEventHandlers = [i];
      else {
        const {
          internalInheritedEventHandlers: r
        } = this, o = [i, ...r], u = {
          onBlur: (l) => {
            o.forEach((s) => {
              s.onBlur(l);
            });
          },
          onFocus: (l) => {
            o.forEach((s) => {
              s.onFocus(l);
            });
          },
          onClick: (l) => {
            o.forEach((s) => {
              s.onClick(l);
            });
          },
          onMouseenter: (l) => {
            o.forEach((s) => {
              s.onMouseenter(l);
            });
          },
          onMouseleave: (l) => {
            o.forEach((s) => {
              s.onMouseleave(l);
            });
          }
        };
        se(t, r ? "nested" : p ? "manual" : this.trigger, u);
      }
    }
    return v(ee, {
      ref: "binderInstRef",
      syncTarget: !d,
      syncTargetWithParent: this.internalSyncTargetWithParent
    }, {
      default: () => {
        this.mergedShowConsideringDisabledProp;
        const i = this.getMergedShow();
        return [this.internalTrapFocus && i ? G(v("div", {
          style: {
            position: "fixed",
            inset: 0
          }
        }), [[ne, {
          enabled: i,
          zIndex: this.zIndex
        }]]) : null, p ? null : v(te, null, {
          default: () => t
        }), v(J, oe(this.$props, ae, Object.assign(Object.assign({}, this.$attrs), {
          showArrow: this.mergedShowArrow,
          show: i
        })), {
          default: () => {
            var r, o;
            return (o = (r = this.$slots).default) === null || o === void 0 ? void 0 : o.call(r);
          },
          header: () => {
            var r, o;
            return (o = (r = this.$slots).header) === null || o === void 0 ? void 0 : o.call(r);
          },
          footer: () => {
            var r, o;
            return (o = (r = this.$slots).footer) === null || o === void 0 ? void 0 : o.call(r);
          }
        })];
      }
    });
  }
});
export {
  Ie as default,
  de as popoverBaseProps,
  ue as popoverProps
};
